import { REPORT_BY_COURSE_SECTION_ROUTE } from "config/route-consts";
import { ProtectedRoute } from "pages/Authentication/ProtectedRoute";
import { Switch } from "react-router-dom";
import ReportByCourseSection from "./ReportByCourseSection";

function ReportByCourseSectionView() {
  return (
    <Switch>
      <ProtectedRoute
        path={REPORT_BY_COURSE_SECTION_ROUTE}
        key={REPORT_BY_COURSE_SECTION_ROUTE}
        component={ReportByCourseSection}
        auth={true}
      />
    </Switch>
  );
}

export { ReportByCourseSectionView };
export default ReportByCourseSectionView;
